module.exports = __webpack_public_path__ + "static/media/charity.2cf85fb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/charity.svg
// module id = 644
// module chunks = 36